import { Icon } from "@iconify/react/dist/iconify.js";
import { brand } from "../../../context";

type InitialSetupProps = {
  onUpload: () => void;
  onFillForm: () => void;
  onChat: () => void;
};

export function InitialSetup({ onUpload, onFillForm, onChat }: InitialSetupProps) {
  return (
    <div className="grid gap-3 grid-cols-3 content-center items-center">
      <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center">
        <Icon
          icon="material-symbols:file-upload"
          className="text-5xl border border-gray-200 rounded-md p-3"
        />
        <span>I have a quotation request document to upload</span>
        <button className="Button" type="button" data-brand={brand} onClick={onUpload}>
          Upload Document
        </button>
      </div>
      <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center">
        <Icon
          icon="material-symbols:description"
          className="text-5xl border border-gray-200 rounded-md p-3"
        />
        <span>I have a quotation request form to fill</span>
        <button className="Button" type="button" data-brand={brand} onClick={onFillForm}>
          Fill Form
        </button>
      </div>
      <div className="border border-gray-100 rounded-md shadow-md p-3 text-center cursor-pointer grid gap-3 place-items-center">
        <Icon
          icon="material-symbols:chat"
          className="text-5xl border border-gray-200 rounded-md p-3"
        />
        <span>I want to chat for a quotation request</span>
        <button className="Button" type="button" data-brand={brand} onClick={onChat}>
          Chat
        </button>
      </div>
    </div>
  );
}
